import Input from 'components/Input';
import MaskedInput from 'components/MaskedInput';
import Select from 'components/SelectSearch';
import { FormikTouched } from 'formik';
import { FormPropsPJType } from 'pages/Register/utils/types/FormPropType/FormPropPJType';
import React, { useEffect, useState } from 'react';
import { cnaeMask, currencyMaskForInput } from 'utils/mask';
import * as S from './styles';
import { findData } from 'services/findCEP';
import { toast } from 'react-toastify';
import { map } from 'lodash';

type InputsAndSelectsOfBasicPJInformationProps = {
  values: FormPropsPJType;
  errorsForm: FormPropsPJType | undefined;
  successForm: FormPropsPJType | undefined;
  touched: FormikTouched<FormPropsPJType>;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
  isModifying?: boolean;
};

export const InputsAndSelectsOfBasicPJInformation: React.FC<
  InputsAndSelectsOfBasicPJInformationProps
> = ({
  values,
  errorsForm,
  successForm,
  touched,
  setFieldValue,
  isModifying,
}) => {
  const [atividadesPrincipais, setAtividadesPrincipais] = useState<any[]>([]);
  const [ramosAtividade, setRamosAtividade] = useState<any[]>([]);

  useEffect(() => {
    findData
      .GetAtividadesEconomicas()
      .then((response) => {
        setAtividadesPrincipais(
          map(response.data, (it: any) => {
            const rawCode = padronizarCnae(String(it.CB12_CD_ATECON));
            const label = `${cnaeMask(rawCode)} - ${it.CB12_NM_ATECON}`;
            return { value: rawCode, label };
          })
        );
      })
      .catch(() => {
        toast.error(
          'Não foi possível carregar os CNAEs, por favor atualize a página.'
        );
      });
  }, []);

  useEffect(() => {
    findData
      .GetRamosAtividade()
      .then((response) => {
        setRamosAtividade(
          map(response.data.data, (it: any) => {
            const value = it.codRamoAtividade;
            const label = it.nomeRamoAtividade;
            return { value, label };
          })
        );
      })
      .catch(() => {
        toast.error(
          'Não foi possível carregar os Ramos de Atividade, por favor atualize a página.'
        );
      });
  }, []);

  function padronizarCnae(cnae: string): string {
    const match = cnae.match(/^([A-Z])(\d{1,7})$/);
    if (!match) return cnae;

    const numeros = match[2].padEnd(7, '0');
    return numeros;
  }

  return (
    <S.Wrapper>
      <S.DivInput>
        <Input
          readOnly={!isModifying}
          name="nome"
          title="Razão Social"
          value={values.nome}
          maxInputLength={50}
          error={errorsForm?.nome === 'true' && successForm?.nome === 'false'}
          valid={
            !!values.nome && !!touched.nome && errorsForm?.nome === 'false'
          }
          onChange={(e) => setFieldValue('nome', e.target.value)}
          disabled={true}
        />

        <MaskedInput
          readOnly={!isModifying}
          name="dataFundacaoEmpresa"
          title="Data de fundação"
          inputMethod="numeric"
          value={values.dataFundacaoEmpresa}
          MaskType="dateDMA"
          maxInputLength={10}
          error={
            errorsForm?.dataFundacaoEmpresa === 'true' &&
            successForm?.dataFundacaoEmpresa === 'false'
          }
          valid={
            !!values.dataFundacaoEmpresa &&
            !!touched.dataFundacaoEmpresa &&
            errorsForm?.dataFundacaoEmpresa === 'false'
          }
          onChange={(e) => setFieldValue('dataFundacaoEmpresa', e.target.value)}
        />

        <Input
          readOnly={!isModifying}
          name="nomeFantasia"
          title="Nome Fantasia"
          value={values.nomeFantasia}
          maxInputLength={50}
          error={
            errorsForm?.nomeFantasia === 'true' &&
            successForm?.nomeFantasia === 'false'
          }
          valid={
            !!values.nomeFantasia &&
            !!touched.nomeFantasia &&
            errorsForm?.nomeFantasia === 'false'
          }
          onChange={(e) => setFieldValue('nomeFantasia', e.target.value)}
        />

        <Input
          name="faturamentoAnual"
          title="Faturamento médio anual"
          value={values.faturamentoAnual}
          error={
            errorsForm?.faturamentoAnual === 'true' &&
            successForm?.faturamentoAnual === 'false'
          }
          valid={
            !!values.faturamentoAnual &&
            !!touched.faturamentoAnual &&
            errorsForm?.faturamentoAnual === 'false'
          }
          onChange={(e) =>
            setFieldValue(
              'faturamentoAnual',
              currencyMaskForInput(e.target.value)
            )
          }
        />

        <Input
          name="inscricaoEstadual"
          title="Inscrição estadual"
          value={values.inscricaoEstadual}
          maxInputLength={9}
          error={
            errorsForm?.inscricaoEstadual === 'true' &&
            successForm?.inscricaoEstadual === 'false'
          }
          valid={
            !!values.inscricaoEstadual &&
            !!touched.inscricaoEstadual &&
            errorsForm?.inscricaoEstadual === 'false'
          }
          onChange={(e) => setFieldValue('inscricaoEstadual', e.target.value)}
        />

        <Select
          title="Atividade principal"
          name="cnae"
          value={values.cnae}
          options={atividadesPrincipais}
          error={errorsForm?.cnae === 'true' && successForm?.cnae === 'false'}
          valid={
            !!values.cnae && !!touched.cnae && errorsForm?.cnae === 'false'
          }
          onChange={(e) => setFieldValue('cnae', e.target.value)}
          searchable
        />

        <Select
          title="Ramo de Atividade"
          name="ramoAtividade"
          value={values.ramoAtividade}
          options={ramosAtividade}
          error={
            errorsForm?.ramoAtividade === 'true' &&
            successForm?.ramoAtividade === 'false'
          }
          valid={
            !!values.ramoAtividade &&
            !!touched.ramoAtividade &&
            errorsForm?.ramoAtividade === 'false'
          }
          onChange={(e) => setFieldValue('ramoAtividade', e.target.value)}
          searchable
        />
      </S.DivInput>
    </S.Wrapper>
  );
};
